function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7511 6.84033H10.0963H1.20366H0.654794H0V16.9367H1.20366H10.0963H11.3V15.733V6.84033H10.7511ZM1.20366 15.733V8.044H10.0963V15.733H1.20366Z",
  fill: "#EA5554"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.33979 7.87559H8.18427V4.43792C8.18427 3.69646 7.88095 2.98871 7.35133 2.48799C6.84098 2.01133 6.18619 1.76579 5.50251 1.80912C5.46399 1.80912 5.42066 1.81393 5.38214 1.81875C4.087 1.95356 3.10962 3.07537 3.10962 4.43311V7.87077H1.9541V4.43311C1.9541 3.49906 2.28631 2.60354 2.89296 1.91023C3.50924 1.20247 4.3518 0.764338 5.26659 0.668045C5.32436 0.66323 5.38214 0.658415 5.43991 0.653601C6.44136 0.595825 7.40429 0.947295 8.14575 1.64542C8.90647 2.3628 9.3446 3.3787 9.3446 4.43792V7.87559H9.33979Z",
  fill: "#EA5554"
});

var SvgOrgSuspend = function SvgOrgSuspend(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrgSuspend, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/org-suspend.f9876372.svg";
export { ForwardRef as ReactComponent };